export default "__VITE_ASSET__GsNukkdN__"